var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 36,
    viewBox: "0 0 264 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147 23.25H135M147 27.75H135M141 32.25L135 32.2497",
    stroke: "#7258F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 9.75H139.125C142.285 9.75 143.865 9.75 145 10.5084C145.491 10.8367 145.913 11.2586 146.242 11.7499C147 12.8849 147 14.84 147 18M132 9.75L131.05 7.84969C130.263 6.27537 129.543 4.69068 127.799 4.03651C127.035 3.75 126.162 3.75 124.416 3.75C121.692 3.75 120.329 3.75 119.307 4.32048C118.578 4.72713 117.977 5.32841 117.57 6.05709C117 7.07934 117 8.4417 117 11.1664V15.75C117 22.821 117 26.3566 119.197 28.5532C121.147 30.5035 124.152 30.7224 129.75 30.7469",
    stroke: "#7258F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6667 22.0834H58.3333M67.6667 25.5834H58.3333M63 29.0834L58.3335 29.0831",
    stroke: "#7258F9",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1667 11.5833H61.5417C63.9995 11.5833 65.2283 11.5833 66.1112 12.1731C66.4934 12.4285 66.8214 12.7566 67.0768 13.1388C67.6667 14.0216 67.6667 15.5422 67.6667 18M56 11.5833L55.261 10.1053C54.6488 8.8808 54.0892 7.64827 52.7325 7.13947C52.1382 6.91663 51.4594 6.91663 50.1017 6.91663C47.9824 6.91663 46.9228 6.91663 46.1277 7.36033C45.561 7.67662 45.0933 8.14427 44.777 8.71103C44.3333 9.50611 44.3333 10.5657 44.3333 12.6849V16.25C44.3333 21.7496 44.3333 24.4996 46.0419 26.208C47.5587 27.7249 49.8962 27.8952 54.25 27.9142",
    stroke: "#7258F9",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.667 22.0834H210.333M219.667 25.5834H210.333M215 29.0834L210.333 29.0831",
    stroke: "#7258F9",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.167 11.5833H213.542C215.999 11.5833 217.228 11.5833 218.111 12.1731C218.493 12.4285 218.821 12.7566 219.077 13.1388C219.667 14.0216 219.667 15.5422 219.667 18M208 11.5833L207.261 10.1053C206.649 8.8808 206.089 7.64827 204.732 7.13947C204.138 6.91663 203.459 6.91663 202.102 6.91663C199.982 6.91663 198.923 6.91663 198.128 7.36033C197.561 7.67662 197.093 8.14427 196.777 8.71103C196.333 9.50611 196.333 10.5657 196.333 12.6849V16.25C196.333 21.7496 196.333 24.4996 198.042 26.208C199.559 27.7249 201.896 27.8952 206.25 27.9142",
    stroke: "#7258F9",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.625H10.5M16.5 22.875H10.5M13.5 25.125L10.5001 25.1248",
    stroke: "#7258F9",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 13.875H12.5625C14.1425 13.875 14.9325 13.875 15.5 14.2542C15.7457 14.4184 15.9566 14.6293 16.1208 14.875C16.5 15.4425 16.5 16.42 16.5 18M9 13.875L8.52495 12.9248C8.13135 12.1377 7.77165 11.3453 6.89944 11.0183C6.51742 10.875 6.08101 10.875 5.2082 10.875C3.84585 10.875 3.16467 10.875 2.65354 11.1602C2.2892 11.3636 1.98857 11.6642 1.78524 12.0285C1.5 12.5397 1.5 13.2209 1.5 14.5832V16.875C1.5 20.4105 1.5 22.1783 2.59835 23.2766C3.57345 24.2518 5.07615 24.3612 7.875 24.3734",
    stroke: "#7258F9",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 20.625H256.5M262.5 22.875H256.5M259.5 25.125L256.5 25.1248",
    stroke: "#7258F9",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.25 13.875H258.562C260.143 13.875 260.932 13.875 261.5 14.2542C261.746 14.4184 261.957 14.6293 262.121 14.875C262.5 15.4425 262.5 16.42 262.5 18M255 13.875L254.525 12.9248C254.131 12.1377 253.772 11.3453 252.899 11.0183C252.517 10.875 252.081 10.875 251.208 10.875C249.846 10.875 249.165 10.875 248.654 11.1602C248.289 11.3636 247.989 11.6642 247.785 12.0285C247.5 12.5397 247.5 13.2209 247.5 14.5832V16.875C247.5 20.4105 247.5 22.1783 248.598 23.2766C249.573 24.2518 251.076 24.3612 253.875 24.3734",
    stroke: "#7258F9",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading-icon.4ba530f25c82eab78ce665bf26b11f9a.svg";
export { ForwardRef as ReactComponent };